import "./shops-assigned-to-plan-notification-modal.scss"
import { observer } from "mobx-react";
import { NotificationModal } from "../../../../components/modal/components/notification-modal/notification-modal";
import { IShop } from "../../../../models/User";

interface ShopsAssignedToPlanNotificationModalProps {
    assignedShops: IShop[];
    planId: number;
    onClose: () => void;
}

const ShopsAssignedToPlanNotificationModal:
    React.FC<ShopsAssignedToPlanNotificationModalProps> = observer(({ assignedShops, planId, onClose }) => {
        let text = assignedShops?.map(s => s.name).join(', ');
        text += ` successfully assigned to plan #${planId}`;
        return (
            <NotificationModal text={text} okButton={{ title: 'ok', onClick: onClose }} />
        );
    });

export default ShopsAssignedToPlanNotificationModal;
